module.exports = __webpack_public_path__ + "static/media/buy_pay_invoice_9.aa66f63e.png";